import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { reducer as burgerMenu } from 'redux-burger-menu';

import { connectRouter } from 'connected-react-router';

import auth from './auth';
import banner from './banner';
import browser from './browser';
import field from './field';
import settings from './settings';
import map from './map';

export default history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    banner,
    browser,
    burgerMenu,
    field,
    form: reduxFormReducer,
    map,
    settings,
  });



// WEBPACK FOOTER //
// ./src/reducers/index.js